import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

interface GoogleReviewLinkHelperProps {
  compact?: boolean;
  className?: string;
}

export function GoogleReviewLinkHelper({ 
  compact = false,
  className 
}: GoogleReviewLinkHelperProps) {

  return (
    <div className={cn(
      "bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg",
      compact ? "p-2" : "p-3",
      className
    )}>
      <p className={cn(
        "font-medium text-blue-800 dark:text-blue-200 mb-2 flex items-center gap-1.5",
        compact ? "text-xs" : "text-sm"
      )}>
        <HelpCircle className={cn(compact ? "w-3 h-3" : "w-4 h-4")} />
        Comment obtenir votre lien d'avis Google ?
      </p>
      <ol className={cn(
        "text-blue-700 dark:text-blue-300 space-y-1 list-decimal list-inside",
        compact ? "text-xs" : "text-sm"
      )}>
        <li>Connectez-vous à votre compte Google associé à votre fiche</li>
        <li>Recherchez le nom de votre établissement dans Google</li>
        <li>Dans le panneau de gestion, cliquez sur <strong>"Demander des avis"</strong></li>
        <li>Copiez le lien court fourni (format: <code className="bg-blue-100 dark:bg-blue-900/50 px-1 rounded">g.page/r/.../review</code>)</li>
      </ol>
    </div>
  );
}
